module.exports = __webpack_public_path__ + "img/vertical_2_1_0.16b9e533.png";